import React from 'react';
import Button from '../../../../common/Button';
import InputWrapper from '../../../../common/InputWrapper';
import { TableContainer } from '../../ServiceProviders/styled';
import { useEffect } from 'react';
import {
  fetchDeleteSkuQtyCorrection,
  fetchGetSkuQtyCorrection,
} from '../../../../../actions/admin';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { CORRECTION_MODS, PER_PAGE_SELECT_OPTIONS } from '../../../../../config';
import Pagination from '../../../../common/Pagination';
import styled from '@emotion/styled';
import SpinnerBlock from '../../../../common/SpinnerBlock';
import { toast } from 'react-toastify';
import { showModal } from '../../../../../actions/modal';

const CORRECTION_TYPE_OPTIONS = {
  ADD: 'Оприходование',
  SUBTRACT: 'Списание',
};

const Wrapper = styled('div')`
  .edit-item {
    .action-icon {
      visibility: hidden;
      margin-left: 5px;
    }

    &:hover {
      .action-icon {
        visibility: initial;
        cursor: pointer;
      }
    }
  }

  .action-icon {
    font-size: 18px;
    margin-left: 50px;
  }

  .correction-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .th {
    border: none;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .text-center {
    text-align: center;
    width: 70px;
  }
`;

const CorrectionsList = ({ handleSwitchMode, mode }) => {
  const dispatch = useDispatch();

  const [skuCorrections, setSkuCorrections] = useState(null);
  const [pageIdx, setPageIdx] = useState(1);
  const [perPageQty, setPerPageQty] = useState(5);

  const [searchId, setSearchId] = useState(null);
  const [searchFalseResult, setFalseSearchResult] = useState(false);

  const [showSpinner, setShowSpinner] = useState(true);

  const updateCorrections = async () => {
    const skuCorrections = await dispatch(
      fetchGetSkuQtyCorrection(`page=${pageIdx}&size=${perPageQty}`),
    );
    setSkuCorrections(skuCorrections);
  };

  useEffect(() => {
    const getSkuQtyCorrection = async () => {
      try {
        await updateCorrections();
      } catch (error) {}
      setShowSpinner(false);
    };
    getSkuQtyCorrection();
  }, []);

  const handlePageSelect = async (pageIndex) => {
    setPageIdx(pageIndex);
    const skuCorrections = await dispatch(
      fetchGetSkuQtyCorrection(`page=${pageIndex}&size=${perPageQty}`),
    );
    setSkuCorrections(skuCorrections);
  };

  const handlePerPageQty = async (perPageQty) => {
    setPerPageQty(perPageQty);
    const skuCorrections = await dispatch(
      fetchGetSkuQtyCorrection(`page=${pageIdx}&size=${perPageQty}`),
    );
    setSkuCorrections(skuCorrections);
  };

  const handleSearchId = async (value) => {
    if (value.length === 0) {
      setSearchId(value);

      const getSkuQtyCorrection = async () => {
        const skuCorrections = await dispatch(
          fetchGetSkuQtyCorrection(`page=${pageIdx}&size=${perPageQty}`),
        );
        setSkuCorrections(skuCorrections);
      };

      getSkuQtyCorrection();
      return;
    }

    setSearchId(value);
    if (value.length > 3) {
      const result = await dispatch(fetchGetSkuQtyCorrection(`id=${value}`));

      if (result.recordsTotal === 0) {
        setFalseSearchResult(true);
        return;
      } else {
        setFalseSearchResult(false);
        setSkuCorrections(result);
      }
    } else {
      return;
    }
  };

  useEffect(() => {
    if (searchId && typeof searchId === 'string' && searchId.length === 0) {
      const getSkuQtyCorrection = async () => {
        const skuCorrections = await dispatch(
          fetchGetSkuQtyCorrection(`page=${pageIdx}&size=${perPageQty}`),
        );
        setSkuCorrections(skuCorrections);
      };

      getSkuQtyCorrection();
    }
  }, [searchId]);

  const handleDeleteCorrection = async (onClose, humanId) => {
    const res = await dispatch(fetchDeleteSkuQtyCorrection(humanId));
    if (res.success) {
      onClose();
      toast.info(`Корректировка #${humanId} удалена`);
      await updateCorrections();
    } else {
      onClose();
      toast.error(`Ошибка при попытке удаления корректировки #${humanId}`);
    }
  };

  const handleRemoveItem = (item) => {
    dispatch(
      showModal('ConfirmRemoveCorrectionItem', {
        handleDeleteCorrection,
        item,
      }),
    );
  };

  return (
    <Wrapper>
      <div style={{ padding: '24px 0' }}>
        <div className="row">
          <div className="col-lg-8">
            <InputWrapper
              noLabel
              className="form-control search-input"
              label="Поиск по ID"
              type="text"
              placeholder="Поиск по ID"
              value={searchId}
              onChange={(e) => handleSearchId(e.target.value)}
              icon="fe-search"
            />
          </div>
        </div>
      </div>
      <div className="row" style={{ padding: '0 13px 20px 13px' }}>
        <Button
          className="btn"
          onClick={() => handleSwitchMode(CORRECTION_MODS.ADD)}
          text="Добавить корректировку"
        />
      </div>
      {!searchFalseResult ? (
        <>
          <TableContainer>
            <div className="fixed-table-container">
              <div className="fixed-table-body">
                <table className="table table-centered">
                  <thead className="thead-light">
                    <tr>
                      <th className="th" />
                      <th className="th">ID</th>
                      <th className="th">Дата создания</th>
                      <th className="th text-center">Кол-во</th>
                      <th className="th text-center">Всего шт</th>
                      <th className="th">Тип корректировки</th>
                      <th className="th">Комментарий</th>
                    </tr>
                  </thead>
                  <tbody>
                    {skuCorrections?.skuQtyCorrectionDtoList?.length > 0 ? (
                      skuCorrections.skuQtyCorrectionDtoList.map((item, index) => {
                        return (
                          <tr key={index} className="edit-item">
                            <td>
                              <div>
                                <i
                                  className="fe-info edit-icon action-icon"
                                  onClick={() => handleSwitchMode(CORRECTION_MODS.INFO, item)}
                                />
                                <i
                                  className="fe-edit edit-icon action-icon"
                                  onClick={() => handleSwitchMode(CORRECTION_MODS.EDIT, item)}
                                />
                                <i
                                  className="fe-trash edit-icon action-icon"
                                  onClick={() => handleRemoveItem(item)}
                                />
                              </div>
                            </td>
                            <td>
                              <div style={{ display: 'flex' }}>
                                <span className="ml-1">{item.humanId}</span>
                              </div>
                            </td>
                            <td>
                              <div>
                                <span className="ml-1" style={{ whiteSpace: 'nowrap' }}>
                                  {item.createTs}
                                </span>
                              </div>
                            </td>
                            <td>
                              <section className="correction-data">
                                <div className="text-center">{item.quantityOfSkus}</div>
                              </section>
                            </td>
                            <td>
                              <section className="correction-data">
                                <div className="text-center">{item.sumItemsInDoc}</div>
                              </section>
                            </td>
                            <td>
                              <section className="correction-data">
                                <div>{CORRECTION_TYPE_OPTIONS[item.correctionType]}</div>
                              </section>
                            </td>
                            <td>
                              <section className="correction-data">
                                <div>{item.comment || ' - '}</div>
                              </section>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <SpinnerBlock show={showSpinner} className="mt-4" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </TableContainer>
          <Pagination
            withPerPageCountSelect
            total={skuCorrections?.recordsTotal}
            currentPage={Number(pageIdx - 1)}
            perPage={perPageQty}
            onPageSelect={(pageIndex) => handlePageSelect(pageIndex + 1)}
            onPerPageSelect={(count) => handlePerPageQty(count)}
            perPageSelectOptions={PER_PAGE_SELECT_OPTIONS}
          />
        </>
      ) : (
        <span>Корректировки не найдены</span>
      )}
    </Wrapper>
  );
};

export default CorrectionsList;
